import Swal, { SweetAlertIcon } from 'sweetalert2'

const ThemedAlert = Swal.mixin({
    background: '#1a1a1a',
    color: '#ffffff',
    confirmButtonColor: '#FCC200',
    iconColor: '#FCC200',
    customClass: {
        popup: 'swal-dark-popup',
        confirmButton: 'swal-dark-btn',
    },
});

export const showAlert = (title: string, text: string, icon: SweetAlertIcon): void => {
    ThemedAlert.fire({ title, text, icon });
};